var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LTconfigurator"},[_c('PageTitle',{staticClass:"title",attrs:{"imagem":"gerenciarplanejamento.png","main":"Configurar LT","sub":""}}),_c('LTconfiguratorBase',{staticClass:"LtTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }